import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { ButtonNew, Box, Text } from 'components/Wrapped';
import { withNamespaces } from 'react-i18next';
import { nestedTranslate } from 'utils/strings';

import styles from './CreateOrder.module.scss';
import { ExternalLink } from 'components/Helpers';

const CreateOrderButton = ({
  isAuthenticated,
  t: translate,
  side,
  tradingPair: { quoteCurrency, baseCurrency },
  enableLogin,
  aeraPassUrl,
  onCreateOrderButtonClick,
}) => {
  const t = nestedTranslate(translate, 'forms.limitOrder');
  const loginButton =
    enableLogin && !aeraPassUrl ? (
      <Link to="/login" className={styles.link}>
        Войти
      </Link>
    ) : (
      <ExternalLink href={aeraPassUrl} className={styles.link}>
        Войти
      </ExternalLink>
    );
  const registerButton =
    enableLogin && !aeraPassUrl ? (
      <Link to="/signup" className={styles.link}>
        Зарегистрироваться
      </Link>
    ) : (
      <ExternalLink href={aeraPassUrl} className={styles.link}>
        Зарегистрироваться
      </ExternalLink>
    );

  return (
    <Fragment>
      {isAuthenticated ? (
        <ButtonNew
          type="button"
          label={t('button', { side })}
          // disabled={props.isSubmitting}
          theme={side === 'BUY' ? 'bright-green' : 'red'}
          onClick={onCreateOrderButtonClick}
        />
      ) : (
        <Box background="rgba(255,255,255,0.1)" pad="10px" round="8px" direction="row">
          <Text size="12px" weight={500}>
            {/* <Trans i18nKey="forms.common.loginOrRegister"> */}
            {loginButton} или {registerButton} для торговли
            {/* </Trans> */}
          </Text>
        </Box>
      )}
    </Fragment>
  );
};

const mapStateToProps = ({
  exchangeSettings: {
    settings: { enableLogin, aeraPassUrl },
  },
  auth: { isAuthenticated },
}) => ({
  isAuthenticated,
  enableLogin,
  aeraPassUrl,
});

export default withNamespaces()(connect(mapStateToProps, null)(CreateOrderButton));
